import { useInvestmentTradeConfirmAccounts, useInvestmentTradeConfirms } from '@egw/api'
import { GenericError, PageHeader } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useParams } from 'react-router'
import { TradeLink } from '../../components'

export const TradeConfirmations: FC = () => {
  const { t } = useTranslation('features-documents')

  const { alias = '' } = useParams<{ alias: string }>()

  const { data, isLoading, error } = useInvestmentTradeConfirms(
    { alias: Number(alias) },
    {
      enabled: Boolean(alias),
    },
  )

  const { data: tradeConfirmAccounts, isLoading: tradeConfirmAccountsLoading } = useInvestmentTradeConfirmAccounts()

  const account = tradeConfirmAccounts?.accounts.find((each) => each.alias === Number(alias))

  return (
    <>
      {isLoading || tradeConfirmAccountsLoading ? (
        <div className="egw-container">
          <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
            <Skeleton count={1} height="100px" className="mb-10" />
            <Skeleton count={5} height="50px" />
          </SkeletonTheme>
        </div>
      ) : null}

      {!isLoading && !tradeConfirmAccountsLoading && (
        <PageHeader
          subtitle={t(`trade_confirmations.title`)}
          title={account?.accountName}
          backLinkUrl={WEALTH_ROUTES.DOCUMENTS.path}
        />
      )}

      {Boolean(error) && (
        <div className="egw-container">
          <GenericError errorMessage={t('common.generic_error')} />
        </div>
      )}

      {data?.confirms.length ? (
        <div className="egw-container pt-0">
          {data.confirms.map((item) => (
            <TradeLink
              key={item.fileKey}
              alias={Number(alias)}
              fileKey={item.fileKey}
              title={item.displayName}
              url={item.url}
            />
          ))}
        </div>
      ) : null}

      {!data?.confirms.length && !isLoading && (
        <div className="egw-container pt-0">
          <div className="bg-bglight text-body px-3 py-3.5">{t('trade_confirmations.no_trade_confirmations')}</div>
        </div>
      )}
    </>
  )
}
